import { render, staticRenderFns } from "./m-about.vue?vue&type=template&id=4cb63f9c&scoped=true"
import script from "./m-about.vue?vue&type=script&lang=js"
export * from "./m-about.vue?vue&type=script&lang=js"
import style0 from "./m-about.vue?vue&type=style&index=0&id=4cb63f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb63f9c",
  null
  
)

export default component.exports